import { useMemo } from 'react';
import { getConfig } from '../config/getConfig';

/**
 * 앱 설정값을 가져오는 Hook
 */
export const useConfig = () => {
    const config = useMemo(() => getConfig(), []);

    return config;
};

/**
 * k8s 환경 여부를 확인하는 Hook
 */
export const useIsK8s = () => {
    const config = useConfig();
    return config.IS_K8S;
};

/**
 * SaaS 환경 여부를 확인하는 Hook
 */
export const useIsSaas = () => {
    const config = useConfig();
    return !config.IS_K8S;
};

/**
 * 특정 profile인지 확인하는 Hook
 */
export const useProfile = (targetProfile) => {
    const config = useConfig();
    return config.PROFILE === targetProfile;
};
